import { ActionIcon, Box, Group, Paper, Text, TextInput, Button } from "@mantine/core";
import React, { useEffect } from "react";
import { X, ArrowsShuffle } from "tabler-icons-react";

function OrganisationForm({ form, index }) {
  const correction_dp = form.values.epreuves[index]?.correction_dp || "";
  const choices = form.values.epreuves[index]?.choices || [];

  const shuffleArray = (array) => {
    const newArray = [...array];
    for (let i = newArray.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
    }
    return newArray;
  };

  const handleShuffle = () => {
    if (correction_dp) {
      const words = correction_dp.split(" ");
      const shuffledWords = shuffleArray(words);
      form.setFieldValue(`epreuves.${index}.choices`, shuffledWords);
    }
  };

  return (
    <Paper mb={20} p={10} shadow="xs">
      <Group noWrap position="apart">
        <Box style={{ flex: 1 }}>
          <TextInput
            label="Titre"
            placeholder="Mettre le titre de l'epreuve"
            {...form.getInputProps(`epreuves.${index}.titre`)}
            mb={10}
          />

          <TextInput
            label="Phrase correcte"
            placeholder="Entrez la phrase correcte"
            {...form.getInputProps(`epreuves.${index}.correction_dp`)}
            mb={10}
          />

          {correction_dp && (
            <Group position="apart" mb={10}>
              <Text size="sm">Mots mélangés:</Text>
              <Button
                leftIcon={<ArrowsShuffle size={16} />}
                size="xs"
                onClick={handleShuffle}
                disabled={!correction_dp}
              >
                Mélanger
              </Button>
            </Group>
          )}

          {choices.length > 0 && (
            <Group spacing={5} wrap>
              {choices.map((word, wordIndex) => (
                <TextInput
                  key={wordIndex}
                  value={word}
                  readOnly
                  style={{ width: 'auto' }}
                />
              ))}
            </Group>
          )}
        </Box>
        <ActionIcon
          color="red"
          onClick={() => form.removeListItem('epreuves', index)}
        >
          <X size="1rem" />
        </ActionIcon>
      </Group>
    </Paper>
  );
}

export default OrganisationForm;
